/** @jsxRuntime classic */ /** @jsx createElement */ import { createElement } from '@fluentui/react-jsx-runtime';
import { getSlotsNext } from '@fluentui/react-utilities';
/**
 * Render the final JSX of CardFooter.
 */ export const renderCardFooter_unstable = (state)=>{
    const { slots , slotProps  } = getSlotsNext(state);
    return /*#__PURE__*/ createElement(slots.root, slotProps.root, slotProps.root.children, slots.action && /*#__PURE__*/ createElement(slots.action, slotProps.action));
};
